/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import StoreLeftMenu from "../../menu/StoreLeftMenu";
// import Footer from "../../components/Footer";

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import CommentItem from '../../components/store/CommentItem';

class OriginalComment extends PureComponent {
  state = {
    gotoPage: 1,
    pageSize: 10,
    pageCount: 1,
    con: 0,
    comment: '',
    isLike: this.props.childProps.isLike ? this.props.childProps.isLike : 0,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    const { idx } = this.props.childProps;
    // const { pageSize } = this.state;
    this._getData(1, idx);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)

    return this.props.childProps.idx !== nextProps.childProps.idx;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.childProps.idx !== nextProps.childProps.idx) {
      this._getData(1, nextProps.childProps.idx);
    }
  };
  _getData = async (gotoPage, idx) => {
    const result = await this._getDataApi(gotoPage, idx);
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const intReturn = result.data[0].intReturn;
    const commentList = result.data[0].listData;

    //console.log(gotoPage, pageCount, con)
    if (this._isLoad) {
      if (intReturn === 0) {
        if (con > 0) {
          this.setState({
            commentList,
            con,
            pageCount,
            gotoPage,
            idx,
          });
        } else {
          this.setState({
            commentList: [],
            con: 0,
            pageCount: 0,
            gotoPage: 1,
            idx,
          });
        }
      } else {
        this.setState({
          commentList: [],
          con: 0,
          pageCount: 0,
          gotoPage: 1,
          idx,
        });
      }
    }
  };
  _getDataApi = (gotoPage, idx) => {
    //const { idx } = this.props.childProps;
    const { apiUrl } = this.props;
    const { pageSize } = this.state;
    return axios
      .post(apiUrl + '/originalComment', {
        params: {
          idx: idx,
          gotoPage: gotoPage,
          pageSize: pageSize,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { commentList } = this.state;

    const list = commentList.map((item, index) => {
      return (
        <CommentItem
          key={index}
          serial={item.serial}
          title={item.title}
          userid={item.userid}
          ip={item.ip}
          regDate={item.regDate}
          nicName={item.nicName}
          charac_img={item.charac_img}
          onDel={this._commentDel}
        />
      );
    });

    return list;
  };
  _renderPage = () => {
    const { pageCount, gotoPage, pageSize, idx } = this.state;
    const pageNumbers = [];
    let blockPage = ((gotoPage - 1) / pageSize) * pageSize + 1;
    let i = 0;
    ////console.log(blockPage, pageCount)
    do {
      pageNumbers.push(i);
      blockPage = blockPage + 1;
      i = i + 1;
    } while (i < pageSize && i < pageCount);
    ////console.log(pageNumbers)
    const list = pageNumbers.map((num, index) => {
      return (
        <a
          key={index}
          onClick={() => this._getData(num + 1, idx)}
          className={gotoPage === num + 1 ? 'active' : null}
          style={{ cursor: 'pointer' }}
        >
          {num + 1}
        </a>
      );
    });

    return list;
  };

  _onCommentReg = async () => {
    const { loginId } = this.props;
    const { comment, idx } = this.state;

    //console.log(comment, starValue)

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용하실 수 있습니다.');
    } else {
      if (comment === '' || comment === null || comment === undefined) {
        toast.warn('내용을 입력해 주세요');
        return false;
      }

      const result = await this._onCommentRegApi(idx);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          this._getData(1, idx);
          this.setState({
            comment: '',
          });
        } else {
          toast.error('등록중 오류가 발생했습니다.');
          //alert('오류가 발생했습니다.')
        }
      }
    }
  };
  _onCommentRegApi = (idx) => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    //const { idx } = this.props.childProps;
    const at = this.getCookie('at');
    const { comment } = this.state;
    //const contentValue = 10
    let strComment;
    strComment = comment.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    return axios
      .post(
        apiUrl + '/originalCommentAdd',
        {
          params: {
            userid: loginId,
            authId: authId,
            idx: idx,
            strTitle: strComment,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('add', idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun, idx) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 'add') {
        this._onCommentReg();
      } else if (gubun === 'del') {
        this._commentDel(idx);
      } else if (gubun === 'like') {
        this._onLike();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onCommentChange = (e) => {
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      //toast.warn('로그인 후 글을 남기실 수 있습니다.')
      alert('로그인 후 글을 남기실 수 있습니다.');
    } else {
      this.setState({
        comment: e.target.value,
      });
    }
  };
  _commentDel = async (serial) => {
    const { idx } = this.state;
    const result = await this._commentDelApi(serial);
    if (result) {
      const intReturn = result.data[0].intReturn;
      if (intReturn === 0) {
        toast.success('정상적으로 삭제되었습니다.');
        this._getData(1, idx);
      }
    }
  };
  _commentDelApi = (serial) => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/originalCommentDel',
        {
          params: {
            userid: loginId,
            authId: authId,
            serial: serial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('del', serial);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onLike = async () => {
    const result = await this._onLikeApi();
    if (result) {
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        //좋아요 성공
        this.setState({
          isLike: 100,
        });
      } else {
        this.setState({
          isLike: 0,
        });
        //좋아요 취소
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onLikeApi = () => {
    const { apiUrl, loginId, history } = this.props;
    const { idx } = this.state;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    return axios
      .post(
        apiUrl + '/originalLike',
        {
          params: {
            idx: idx,
            userid: loginId,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('like', idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onPrev = () => {
    const { gotoPage, idx } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1, idx);
    }
  };
  _onNext = () => {
    const { pageCount, gotoPage, idx } = this.state;

    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1, idx);
    }
  };
  render() {
    // const { idx } = this.props.childProps;
    const { commentList, pageCount, con, comment, isLike } = this.state;
    const { imgUrl } = this.props;
    return (
      <div className="reply_wrap">
        <h3 className="tit">
          댓글<span>{con}</span>
        </h3>
        {/* 댓글 쓰기 */}
        <form className="reply_form">
          <div className="user_img">
            <span className="thumb">
              <img src={imgUrl + '/img/store/sample_img11.png'} />
            </span>
          </div>
          <div className="write_wrap">
            <button
              type="button"
              className={parseInt(isLike) > 0 ? 'btn_like active' : 'btn_like'}
              onClick={this._onLike}
            >
              <i className="ico_like"></i> LIKE IT
            </button>
            {/* 활성화 시 active */}
            <button
              type="button"
              className="btn_ok"
              onClick={this._onCommentReg}
            >
              확인
            </button>
            <textarea
              value={comment}
              onChange={this._onCommentChange}
              className="reply_write"
              placeholder="공감과 응원의 댓글은 직원들에게 큰 힘이 됩니다."
            ></textarea>
          </div>
        </form>
        {/* 댓글 리스트 */}
        <div className="reply_list">
          {commentList ? this._renderItem() : null}
        </div>
        {/* 페이지네이션 */}
        <div className="pagination">
          <a className="prev" onClick={this._onPrev}>
            이전
          </a>
          {pageCount > 0 ? (
            this._renderPage()
          ) : (
            <span style={{ cursor: 'pointer' }} className="on">
              1
            </span>
          )}
          <a className="next" onClick={this._onNext}>
            다음
          </a>
        </div>
      </div>
    );
  }
}

export default shopContext(withRouter(React.memo(OriginalComment)));
